// Shared with the Shopify theme. Only consented, short campaign identifiers;
// never a URL, photograph, gallery token or customer detail.
(() => {
  const keys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
  ];
  const slug = /^[a-z0-9][a-z0-9._~-]{0,63}$/i;
  const value = (name) =>
    document.cookie
      .split(";")
      .map((v) => v.trim())
      .find((v) => v.startsWith(`${name}=`))
      ?.slice(name.length + 1) || "";
  const domain = () =>
    /(^|\.)mapia\.studio$/.test(location.hostname)
      ? "; Domain=.mapia.studio"
      : "";
  const allowed = () => value("mapia_analytics_consent") === "1";
  const clean = (input) =>
    Object.fromEntries(
      keys.flatMap((key) =>
        typeof input?.[key] === "string" && slug.test(input[key])
          ? [[key, input[key].toLowerCase()]]
          : [],
      ),
    );
  const clear = () => {
    for (const suffix of new Set(["", domain()]))
      for (const name of ["mapia_campaign", "mapia_visit"])
        document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax${location.protocol === "https:" ? "; Secure" : ""}${suffix}`;
  };
  const read = () => {
    if (!allowed()) {
      clear();
      return {};
    }
    try {
      const saved = JSON.parse(decodeURIComponent(value("mapia_campaign")));
      if (
        !Number.isFinite(saved.at) ||
        saved.at > Date.now() ||
        Date.now() - saved.at > 30 * 86400000
      ) {
        clear();
        return {};
      }
      return clean(saved);
    } catch {
      return {};
    }
  };
  const capture = () => {
    const saved = read();
    if (!allowed() || Object.keys(saved).length) return saved;
    const current = clean(
      Object.fromEntries(new URL(location.href).searchParams),
    );
    if (current.utm_source)
      document.cookie = `mapia_campaign=${encodeURIComponent(JSON.stringify({ ...current, at: Date.now() }))}; Path=/; Max-Age=2592000; SameSite=Lax${location.protocol === "https:" ? "; Secure" : ""}${domain()}`;
    return current.utm_source ? current : {};
  };
  const visit = () => {
    if (!allowed()) return "";
    const existing = value("mapia_visit");
    const id =
      /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
        existing,
      )
        ? existing
        : crypto.randomUUID();
    document.cookie = `mapia_visit=${id}; Path=/; Max-Age=1800; SameSite=Lax${location.protocol === "https:" ? "; Secure" : ""}${domain()}`;
    return id;
  };
  window.MapiaAttribution = { read, capture, clear, allowed, keys, visit };
})();
